import { Dispatch, MouseEvent, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import { SelectionType } from './SelectorTypes';

import './MultiElementSelectorHeader.css';

export default function SelectionToggle({
  selectedCount,
  allRowCount,
  selectionState,
  setSelectionState,
}: {
  selectedCount: number;
  allRowCount: number | undefined;
  selectionState: string;
  setSelectionState: Dispatch<SetStateAction<SelectionType>>;
}) {
  const { t } = useTranslation();

  function handleChange(event: MouseEvent<HTMLElement>, newSelected: SelectionType) {
    if (!event || !newSelected) return;
    setSelectionState(newSelected);
  }

  function SmallCount({ count }: { count: number | undefined }) {
    if (!count) return null;

    return (
      <Typography
        data-qa-element-id="target_count_label"
        variant="caption"
        component="div"
        sx={{ marginLeft: 0.5, letterSpacing: -0.5, lineHeight: 1, fontSize: 11, fontWeight: 500 }}
      >
        ({count})
      </Typography>
    );
  }

  return (
    <div className="selection-toggle">
      <ToggleButtonGroup
        value={selectionState}
        exclusive
        onChange={handleChange}
        className="custom-toggle-group"
        data-qa-element-id="target_selection_picker_panel"
      >
        <ToggleButton
          value="all"
          className="custom-toggle-button"
          sx={{ whiteSpace: 'nowrap' }}
          data-qa-element-id="every_target_button"
        >
          {t('filter.toggle.all')} {allRowCount && <SmallCount count={allRowCount} />}
        </ToggleButton>
        <ToggleButton
          value="selected"
          className="custom-toggle-button"
          sx={{ whiteSpace: 'nowrap' }}
          data-qa-element-id="selected_targets_button"
        >
          {t('filter.toggle.selected')} <SmallCount count={selectedCount} />
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
}
